import { API_URL } from '../circulusConfig';
import { encodeGetParams, getHeaders } from '../common/util';
import { POST, PATCH, PUT } from '../common/consts';

const getSubUsersAPI = async ({ userId, ...rest }) => {
  const res = await fetch(
    `${API_URL}subuser/${userId}?${encodeGetParams(rest)}`,
  );
  const result = res.json();
  return result;
};

const setSubUserAPI = async (subUser) => {
  const res = await fetch(`${API_URL}subuser`, {
    method: POST,
    body: subUser,
  });
  const result = res.json();
  return result;
};

const updateSubUserAPI = async (subUser) => {
  const res = await fetch(`${API_URL}subuser`, {
    method: PUT,
    body: subUser,
  });
  const result = res.json();
  return result;
};

const deleteSubUserAPI = async (subUser) => {
  const res = await fetch(
    `${API_URL}subuser`,
    getHeaders(PATCH, { ...subUser }),
  );
  const result = res.json();
  return result;
};

// 204.검색을 위한 로봇 데이터 목록 가져오기
const getUserRobotsAPI = async ({ userId, type }) => {
  const res = await fetch(
    `${API_URL}subuser/robots?${encodeGetParams({ userId, type })}`,
  );
  const result = res.json();
  return result;
};

const getdetectFaceAPI = async (image) => {
  const res = await fetch(`${API_URL}subuser/detectFace`, {
    method: POST,
    body: image,
  });
  const result = res.json();
  return result;
};

export {
  getSubUsersAPI,
  setSubUserAPI,
  updateSubUserAPI,
  deleteSubUserAPI,
  getUserRobotsAPI,
  getdetectFaceAPI,
};
